export default __webpack_public_path__ + "static/char-s-10-en-5c775aeff6f6577c6ed754ac1876f59a.webp";